import { Country } from "../../api";
import { getLanguages } from "../hooks";

export const makeLanguageOptions = (countries: Country[], countryCode: string) => {
  const languages = getLanguages(countries, countryCode);
  return languages.map(({ code, label }) => ({ value: code, label }));
}

export const makeCountryOptions = (countries: Country[]) => {
  return countries
    .map(({ name, code, nativeName }) => ({ label: nativeName ? nativeName : name, value: code }));
}
